export default "__VITE_ASSET__fd6bb500__"